import { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Space } from '@g2u/ui-kit';
import { useNavigate } from 'react-router-dom';

import { Condition, type JsonDataItem, type WithOptionalDataTest } from 'types';
import { BookingStore, RootStore } from 'store';

type Props = {
  customer: JsonDataItem | null;
  isDisabled: boolean;
} & WithOptionalDataTest;

export const Actions: FC<Props> = observer((props) => {
  const { customer, isDisabled } = props;
  const { setCustomer } = BookingStore;
  const { user } = RootStore;
  const navigate = useNavigate();
  const isBookingRestricted =
    ([customer?.overdue, customer?.bad_debt].includes(Condition.Yes) && !user?.overdue_override) ||
    customer?.blacklist === Condition.Yes;

  return (
    <Space.$ direction={Space.Direction.Horizontal} size={Space.Size.Small} justify={Space.Justify.End}>
      <Button.$
        dataTestId="open-customer-tickets"
        onClick={() => {
          setCustomer(customer);
          navigate(`/tasks/tickets?search_value=${customer?.ID}&search_type=customer_id`);
        }}
        disabled={!customer}
      >
        Open Tickets
      </Button.$>
      <Button.$
        dataTestId="create-parts-only-job"
        onClick={() => {
          setCustomer(customer);
          navigate(`/customer/create-parts-only-job/${customer?.ID}`);
        }}
        disabled={!customer || isDisabled || isBookingRestricted}
      >
        Parts Only Job
      </Button.$>
      <Button.$
        dataTestId="book-a-job"
        onClick={() => {
          setCustomer(customer);
          navigate('/booking/location');
        }}
        disabled={!customer || isDisabled || isBookingRestricted}
      >
        New Booking
      </Button.$>
    </Space.$>
  );
});
